import Head from 'next/head'
import React from 'react'
import { useIntl } from 'react-intl'
import { Abilities, useAbility } from '@utils/useAbility'
import ErrorPage from '@src/pages/_error'

import QuickOrderRoute from '../../../../routes/QuickOrder'

const QuickOrder = () => {
  const { formatMessage } = useIntl()
  const { authorized } = useAbility(Abilities.canAddToCart)

  if (authorized) {
    return (
      <>
        <Head>
          <title>
            {formatMessage({
              id: 'QUICK_ORDER',
              defaultMessage: 'Quick Order',
            })}
          </title>
        </Head>
        <QuickOrderRoute />
      </>
    )
  } else {
    return <ErrorPage statusCode={404} />
  }
}

export default QuickOrder
